import ReferencesContainer from './ReferencesContainer';

export default { ReferencesContainer };
